<template>
  <div>
    <v-toolbar dark prominent>
      <v-app-bar-nav-icon>
        <v-icon color="blue darken-2" @click="backButton">
          mdi-arrow-left
        </v-icon>
      </v-app-bar-nav-icon>

      <v-col cols="10" md="12" sm="10">
        <v-img
          src="/img/fantasy_lineups_logo.png"
          class="logo mx-auto"
          width="350"
          contain
        />
      </v-col>
    </v-toolbar>

    <!--//* tabs... -->

    <v-tabs
      v-model="tab"
      background-color="green accent-3"
      centered
      dark
      icons-and-text
    >
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">
        New Trials
        <v-icon>mdi-new-box</v-icon>
      </v-tab>

      <v-tab href="#tab-2">
        State
        <v-icon>mdi-sign-text</v-icon>
      </v-tab>

      <v-tab href="#tab-3">
        Revenue
        <v-icon>mdi-sign-text</v-icon>
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item value="tab-1">
        <new-trail :reportData="reportData.data" />
      </v-tab-item>

      <v-tab-item value="tab-2">
        <state :reportData="reportData.data" />
      </v-tab-item>

      <v-tab-item value="tab-3">
        <revenue />
      </v-tab-item>
    </v-tabs-items>

    <!-- report table -->
  </div>
</template>

<script>
import { mapState } from "vuex";

import newTrial from "@/components/reportTable/newTrial.vue";
import State from "@/components/reportTable/state.vue";
import Revenue from "@/components/reportTable/revenue.vue";

export default {
  components: { newTrial, State, Revenue },
  name: "reportTable",
  data() {
    return {
      tab: null,
    };
  },

  beforeRouteEnter(to, from, next) {
    if (localStorage.getItem("role") !== "client") {
      next({ name: "Pricing" });
    } else {
      next();
    }
  },

  created() {
    this.fetchReportData();
  },
  computed: {
    ...mapState("userModule", ["reportData"]),
  },

  methods: {
    backButton() {
      this.$router.go(-1);
    },

    fetchReportData() {
      this.$store.dispatch("userModule/getReportData");
    },
  },
};
</script>

<style></style>
